import React from 'react';
import './404-style.css';
const ErrorPage = () => {
	return (
		<>
			<div className='error-outer' style={{marginTop:"70px"}}>
				<div id='error-page'>
					<div className='content'>
						<a href='/' className='logo'>
							<img src='hr-logo.png' alt='' />
						</a>
						<h2 className='header' data-text='404'>
							404
						</h2>
						<h4 data-text='Opps! Page not found'>Opps! Page not found</h4>
						<p>
							Sorry, the page you are looking for doesnot exist. If you think
							something is broken, report a problem.
						</p>
						<div className='btns'>
							<a href='/'>return home</a>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default ErrorPage;
